export default __webpack_public_path__ + "static/dominicana-flag-5346bfba909cc930d7c8a5bc8f545fdd.svg";